const en = {
  // ── Navbar ──────────────────────────────────────
  nav_solutions: 'Solutions',
  nav_infrastructure: 'Infrastructure',
  nav_security: 'Security',
  nav_cases: 'Case Studies',
  nav_about: 'About Us',
  nav_contact_cta: 'Get a Quote',
  nav_whatsapp: 'WhatsApp',

  // ── Hero ─────────────────────────────────────────
  hero_badge: 'Enterprise IT Solutions Provider',
  hero_title1: 'Enterprise-Grade Security',
  hero_title2: '& Smart IT Systems',
  hero_highlight1: 'Enterprise Firewall Deployment',
  hero_highlight2: 'Network Infrastructure Design',
  hero_highlight3: 'Custom System Development',
  hero_focus: 'Specialized in',
  hero_desc: 'We provide comprehensive IT services for SMEs and large enterprises — from system development and network infrastructure to cybersecurity protection, safeguarding your digital assets.',
  hero_cta1: 'Free Security Assessment',
  hero_cta2: 'View Case Studies',
  stat_clients: 'Enterprise Clients',
  stat_uptime: 'System Uptime',
  stat_support: '24/7 Support',

  // ── Services ─────────────────────────────────────
  services_badge: 'Core Services',
  services_title: 'Comprehensive Enterprise IT Solutions',
  services_desc: 'From system development to cybersecurity, we provide one-stop IT services to keep your business competitive in the digital era',
  svc1_title: 'System Development',
  svc1_desc: 'Customize enterprise systems, ERP, cloud applications and mobile solutions to enhance operational efficiency and drive digital transformation.',
  svc1_f1: 'ERP / CRM Systems',
  svc1_f2: 'Cloud SaaS Apps',
  svc1_f3: 'API Integration',
  svc1_f4: 'Mobile Applications',
  svc2_title: 'Network Infrastructure',
  svc2_desc: 'Design efficient, scalable enterprise networks, optimize cross-office and international connectivity, resolving latency and bandwidth bottlenecks.',
  svc2_f1: 'SD-WAN Solutions',
  svc2_f2: 'LAN / WAN Optimization',
  svc2_f3: 'Wireless Coverage',
  svc2_f4: 'Network Monitoring',
  svc3_title: 'Cybersecurity',
  svc3_desc: 'Deploy Next-Gen Firewalls (NGFW), WAF and intrusion detection systems to proactively defend against hackers, ransomware and DDoS threats.',
  svc3_f1: 'NGFW Firewall Deployment',
  svc3_f2: 'WAF Web Protection',
  svc3_f3: 'DDoS Mitigation',
  svc3_f4: 'Penetration Testing',
  learn_more: 'Learn More',

  // ── Features / Why Choose Us ──────────────────────
  features_badge: 'Why Choose Us',
  features_title1: 'Technical Excellence',
  features_title2: 'Your Trusted IT Partner',
  features_desc: 'We\'re not just a service provider — we\'re your long-term partner for IT transformation. Full technical support from solution design to deployment.',
  feat_r1_title: 'Senior Technical Team',
  feat_r1_desc: 'Our core team members hold international certifications from Cisco, Fortinet, Palo Alto with 15+ years of enterprise IT experience.',
  feat_r2_title: '24/7 Technical Support',
  feat_r2_desc: 'Emergency response services with average fault response under 30 minutes, ensuring your business runs without interruption.',
  feat_r3_title: 'Proactive Security Defense',
  feat_r3_desc: 'Don\'t wait for threats — through regular security assessments and monitoring, we identify and eliminate risks proactively.',
  feat_r4_title: 'Deep Industry Knowledge',
  feat_r4_desc: 'Serving retail, finance, manufacturing, healthcare and more — we understand compliance requirements and technical pain points of each industry.',
  cert_title: 'Technical Certifications & Credentials',
  cert_desc: 'Our team holds multiple internationally recognized IT certifications, ensuring services meet the highest industry standards',
  cert_completed: 'Projects Completed',
  cert_satisfaction: 'Client Satisfaction',
  cert_incidents: 'Security Incidents',

  // ── Case Studies (home preview) ──────────────────
  cases_badge: 'Case Studies',
  cases_title: 'Solving Real IT Challenges for Enterprises',
  cases_sub: '200+ successful projects across all industries',
  cases_view_all: 'View All Cases',
  case1_tag: 'Retail',
  case1_title: 'IT Infrastructure Upgrade for Large Retail Chain',
  case1_desc: 'Redesigned SD-WAN network for a 50+ store retailer, centralized POS management, significantly reducing network failure rate.',
  case1_m1: 'Network Uptime',
  case1_m2: 'OpEx Reduction',
  case2_tag: 'Finance',
  case2_title: 'Next-Gen Firewall Deployment for Finance Company',
  case2_desc: 'Deployed Fortinet NGFW and WAF for a licensed financial company, meeting international compliance requirements and defending against multiple targeted attacks.',
  case2_m1: 'Compliance Achieved',
  case2_m2: 'Security Incidents',
  case3_tag: 'Manufacturing',
  case3_title: 'Custom ERP System Development for Factory',
  case3_desc: 'Developed an ERP system integrating production scheduling, inventory management and financial reporting for a global manufacturer.',
  case3_m1: 'Production Efficiency Boost',
  case3_m2: 'ROI Period',

  // ── CTA ──────────────────────────────────────────
  cta_badge: 'Free Enterprise Security Assessment',
  cta_title1: 'Understand Your Enterprise',
  cta_title2: 'IT Security Risk Level',
  cta_desc: 'Our technical consultants will provide a free IT infrastructure assessment, identifying vulnerabilities and improvement recommendations — no hidden fees.',
  cta_btn: 'Schedule Free Assessment',
  cta_note1: 'Free consultation, no commitment',
  cta_note2: 'Reply within 24 hours',
  cta_note3: 'NDA guaranteed',

  // ── Footer ───────────────────────────────────────
  footer_desc: 'A global enterprise IT service provider, specializing in system development, network infrastructure and cybersecurity to protect your digital assets worldwide.',
  footer_services_heading: 'Services',
  footer_company_heading: 'Company',
  footer_hours_title: 'Business Hours',
  footer_hours_weekday: 'Mon–Fri  9:00–18:00',
  footer_hours_emergency: 'Emergency support 24/7 year-round',
  footer_copyright: '© 2026 A&B System Company, LTD. All Rights Reserved.',
  footer_security: 'SSL Protected · Cloudflare WAF',

  // ── Solutions Page ────────────────────────────────
  sol_breadcrumb_home: 'Home',
  sol_breadcrumb_current: 'System Development',
  sol_badge: 'Custom System Development',
  sol_title1: 'Custom System Development',
  sol_title2: 'Driving Enterprise Digital Transformation',
  sol_desc: 'Custom-built enterprise management systems engineered for your unique business needs. From requirements analysis to go-live, we provide full technical support to help you improve efficiency, reduce costs, and achieve intelligent operations.',
  sol_cta1: 'Free Consultation',
  sol_cta2: 'View Development Cases',
  sol_grid_title: 'Our Development Services',
  sol_grid_sub: 'Covering every key aspect of enterprise digital transformation',
  sol_s1_title: 'Enterprise Resource Planning (ERP)',
  sol_s1_desc: 'An integrated management platform covering finance, procurement, production, sales, and HR — eliminating data silos and streamlining cross-departmental collaboration.',
  sol_s1_f1: 'Multi-department data integration',
  sol_s1_f2: 'Real-time financial reports',
  sol_s1_f3: 'Automated workflows',
  sol_s1_f4: 'Role-based access control',
  sol_s2_title: 'Cloud SaaS Application Development',
  sol_s2_desc: 'Cloud-native application development on Microsoft Azure / AWS, ensuring high availability, elastic scalability and reduced IT infrastructure costs.',
  sol_s2_f1: 'Cloud-native architecture',
  sol_s2_f2: 'Auto-scaling',
  sol_s2_f3: '99.9% SLA guarantee',
  sol_s2_f4: 'Multi-cloud deployment',
  sol_s3_title: 'Mobile Applications',
  sol_s3_desc: 'Development of iOS and Android enterprise mobile apps, empowering staff to manage business operations anytime, anywhere — boosting flexibility for field teams and management.',
  sol_s3_f1: 'iOS / Android native dev',
  sol_s3_f2: 'Offline mode support',
  sol_s3_f3: 'Enterprise MDM integration',
  sol_s3_f4: 'Push notification system',
  sol_s4_title: 'API Integration & Third-Party Connectivity',
  sol_s4_desc: 'Connect existing systems with third-party platforms (e-commerce, logistics, payments, government services) to streamline data flow and reduce manual work.',
  sol_s4_f1: 'RESTful / GraphQL API',
  sol_s4_f2: 'Webhook automation',
  sol_s4_f3: 'Legacy system modernization',
  sol_s4_f4: 'Data migration solutions',
  sol_process_title: 'Development Process',
  sol_process_sub: 'Transparent and controllable project management — you are always in the loop',
  sol_p1_step: '01',
  sol_p1_title: 'Requirements Analysis',
  sol_p1_desc: 'Deep dive into business processes and pain points — define functional scope and technical specifications',
  sol_p2_step: '02',
  sol_p2_title: 'System Design',
  sol_p2_desc: 'Architecture design, database modeling, UI/UX prototype confirmation',
  sol_p3_step: '03',
  sol_p3_title: 'Iterative Development',
  sol_p3_desc: 'Agile development with regular progress demos and rapid response to requirement changes',
  sol_p4_step: '04',
  sol_p4_title: 'Testing & Launch',
  sol_p4_desc: 'Comprehensive testing (UAT, stress testing) before deployment, with training provided',
  sol_p5_step: '05',
  sol_p5_title: 'Maintenance & Support',
  sol_p5_desc: 'Long-term technical support, system updates and continuous optimization service',
  sol_cta_title: 'Ready to Start Your System Development Project?',
  sol_cta_desc: 'Contact our technical consultants for a free requirements assessment and project quotation',
  sol_cta_btn: 'Get a Free Quote',

  // ── Infrastructure Page ───────────────────────────
  infra_breadcrumb_home: 'Home',
  infra_breadcrumb_current: 'Network Infrastructure',
  infra_badge: 'Network Infrastructure',
  infra_title1: 'Enterprise Network Architecture',
  infra_title2: 'Efficient, Stable & Scalable',
  infra_desc: 'We design and deploy modern network infrastructure for global enterprises — solving cross-office connectivity, network stability and scalability issues so your business is never held back by network bottlenecks.',
  infra_cta1: 'Free Network Assessment',
  infra_cta2: 'View Network Cases',
  infra_pain_title: 'Are You Facing These Network Challenges?',
  infra_pain_sub: 'Common pain points we resolve for enterprises daily.',
  infra_pain1: 'Frequent office network dropouts or instability',
  infra_pain2: 'Severe latency in cross-border video conferences',
  infra_pain3: 'Difficulty managing multiple branch offices uniformly',
  infra_pain4: 'Network issues disrupting business operations',
  infra_pain5: 'Existing network unable to support business growth',
  infra_pain6: 'Lack of network visibility and monitoring',
  infra_svc_title: 'Network Infrastructure Services',
  infra_svc_sub: 'End-to-end network engineering services from design to deployment',
  infra_s1_title: 'SD-WAN Optimization',
  infra_s1_desc: 'Use software-defined WAN technology to centrally manage network connections across multiple office locations, dynamically allocate bandwidth and ensure critical business applications get priority.',
  infra_s1_f1: 'Multi-link load balancing',
  infra_s1_f2: 'Intelligent path selection',
  infra_s1_f3: 'Centralized management portal',
  infra_s1_f4: 'QoS quality of service',
  infra_s2_title: 'Enterprise Wireless Network Coverage',
  infra_s2_desc: 'High-density wireless network solutions for offices, warehouses and factories — supporting large numbers of simultaneous devices with stable full-site coverage.',
  infra_s2_f1: 'Wi-Fi 6/6E deployment',
  infra_s2_f2: 'Guest network isolation',
  infra_s2_f3: 'Wireless intrusion detection',
  infra_s2_f4: 'Location-aware analytics',
  infra_s3_title: 'Data Center & Server Architecture',
  infra_s3_desc: 'Plan and build enterprise-grade data centers including server virtualization, storage architecture design and backup disaster recovery solutions to safeguard your data.',
  infra_s3_f1: 'VMware / Hyper-V virtualization',
  infra_s3_f2: 'SAN / NAS storage',
  infra_s3_f3: 'Backup & disaster recovery',
  infra_s3_f4: 'Data center environment monitoring',
  infra_s4_title: 'LAN Design & Implementation',
  infra_s4_desc: 'Design high-performance, highly available internal network architecture for enterprise office environments — including switch and router configuration and network segmentation planning.',
  infra_s4_f1: 'VLAN network segmentation',
  infra_s4_f2: 'Core/Distribution/Access 3-tier architecture',
  infra_s4_f3: 'Redundant link design',
  infra_s4_f4: 'Network documentation & diagrams',
  infra_cta_title: 'Let Us Assess Your Existing Network Architecture',
  infra_cta_desc: 'Our engineers will conduct a comprehensive on-site assessment and provide targeted network optimization recommendations — completely free, with no obligation.',
  infra_cta_btn: 'Book a Free Assessment',

  // ── Security Page ─────────────────────────────────
  sec_breadcrumb_home: 'Home',
  sec_breadcrumb_current: 'Cybersecurity',
  sec_badge: 'Cybersecurity & Firewall',
  sec_title1: 'Proactive Defense,',
  sec_title2: 'Not Reactive Remediation',
  sec_desc: 'We build a multi-layered defense system to protect you before hackers strike. From firewall deployment to penetration testing, we comprehensively protect your enterprise digital assets.',
  sec_cta1: 'Free Security Assessment',
  sec_cta2: 'Security Case References',
  sec_threats_title: 'Major Cyber Threats Facing Enterprises Today',
  sec_threats_sub: 'Cybersecurity threats to Global businesses are intensifying — proactive defense is urgent',
  sec_t1_name: 'Ransomware',
  sec_t1_stat: 'Extorting critical business data',
  sec_t2_name: 'Phishing',
  sec_t2_stat: 'Leading cause of credentials theft',
  sec_t3_name: 'DDoS Attacks',
  sec_t3_stat: 'Paralyzing business operations',
  sec_t4_name: 'Insider Threats',
  sec_t4_stat: 'Exploiting internal access privileges',
  sec_svc_title: 'Cybersecurity Services',
  sec_svc_sub: 'Multi-layered defense strategy — comprehensive protection for your enterprise information assets',
  sec_s1_title: 'Next-Generation Firewall (NGFW)',
  sec_s1_badge: 'Fortinet · Palo Alto · Cisco',
  sec_s1_desc: 'Deploy next-gen firewalls with application identification, intrusion prevention (IPS) and SSL deep inspection to effectively block advanced persistent threats (APT) and ransomware.',
  sec_s1_f1: 'Application-layer traffic control',
  sec_s1_f2: 'SSL/TLS deep decryption',
  sec_s1_f3: 'Threat intelligence integration',
  sec_s1_f4: 'Zero-trust architecture support',
  sec_s2_title: 'Web Application Firewall (WAF)',
  sec_s2_badge: 'Cloudflare · F5 · AWS WAF',
  sec_s2_desc: 'Protect enterprise websites and web applications from SQL injection, XSS cross-site attacks and OWASP Top 10 vulnerabilities — meeting PCI DSS compliance requirements.',
  sec_s2_f1: 'OWASP Top 10 protection',
  sec_s2_f2: 'DDoS mitigation',
  sec_s2_f3: 'Bot management',
  sec_s2_f4: 'API security protection',
  sec_s3_title: 'Intrusion Detection & Prevention (IDS/IPS)',
  sec_s3_badge: 'Snort · Suricata · Splunk',
  sec_s3_desc: '24/7 network traffic monitoring with real-time detection of anomalous behavior and intrusion attempts, automatic blocking triggers and security incident reports.',
  sec_s3_f1: 'Behavioral anomaly detection',
  sec_s3_f2: 'Automated threat response',
  sec_s3_f3: 'SIEM log integration',
  sec_s3_f4: 'Compliance audit reports',
  sec_s4_title: 'Penetration Testing & Security Assessment',
  sec_s4_badge: 'CREST · OWASP Standards',
  sec_s4_desc: 'Simulate hacker attack techniques to comprehensively penetration-test enterprise systems, identify security vulnerabilities and provide remediation recommendations.',
  sec_s4_f1: 'Black-box / white-box testing',
  sec_s4_f2: 'Social engineering testing',
  sec_s4_f3: 'Vulnerability scan report',
  sec_s4_f4: 'Remediation recommendations',
  sec_compliance_title: 'Compliance Support',
  sec_compliance_desc: 'We help enterprises meet international and regional data protection regulations including GDPR, PCI DSS, ISO 27001 and other cybersecurity compliance requirements — avoiding fines and reputational damage.',
  sec_cta_title: 'Discover Your Enterprise Security Vulnerabilities Now',
  sec_cta_desc: 'Our security experts will provide a free enterprise cybersecurity risk assessment to identify potential threats',
  sec_cta_btn: 'Book a Free Security Assessment',

  // ── Case Studies Page ─────────────────────────────
  cs_badge: 'SUCCESS STORIES',
  cs_hero_title1: 'Real Enterprise IT Transformation',
  cs_hero_title2: 'Success Cases',
  cs_hero_desc: 'From cybersecurity to system development, we solve real IT challenges for businesses across every industry — each case is a testament to the trust our clients place in us',
  cs_stat1_label: 'Projects Completed',
  cs_stat2_label: 'Industries Served',
  cs_stat3_label: 'Client Satisfaction',
  cs_filter_all: 'All',
  cs_filter_retail: 'Retail',
  cs_filter_finance: 'Finance',
  cs_filter_healthcare: 'Healthcare',
  cs_label_challenge: 'Challenge',
  cs_label_solution: 'Solution',
  cs_c1_industry: 'Retail',
  cs_c1_company: 'Large Retail Chain Group',
  cs_c1_challenge: "The group's 50+ branches operated on separate networks, making IT management complex, cross-store data sync slow, and POS systems frequently disconnecting during operations.",
  cs_c1_solution: 'Designed and deployed a unified WAN based on Fortinet SD-WAN, centralizing management across all branches and upgrading the POS-to-HQ ERP integration interface.',
  cs_c1_r1_metric: '99.8%',
  cs_c1_r1_label: 'Network Uptime',
  cs_c1_r2_metric: '60%',
  cs_c1_r2_label: 'OpEx Reduction',
  cs_c1_r3_metric: '50+',
  cs_c1_r3_label: 'Stores Covered',
  cs_c1_t1: 'SD-WAN',
  cs_c1_t2: 'Network Infrastructure',
  cs_c1_t3: 'ERP Integration',
  cs_c2_industry: 'Finance',
  cs_c2_company: 'Licensed Finance Company',
  cs_c2_challenge: 'The company stores large volumes of client financial data and needed to comply with international financial regulations while defending against an increasing number of targeted cyberattacks.',
  cs_c2_solution: 'Deployed Palo Alto NGFW and WAF to establish a multi-layered defense architecture with granular access control policies, validated by third-party penetration testing.',
  cs_c2_r1_metric: '100%',
  cs_c2_r1_label: 'Compliance',
  cs_c2_r2_metric: '0',
  cs_c2_r2_label: 'Security Incidents',
  cs_c2_r3_metric: '3x',
  cs_c2_r3_label: 'Attacks Blocked',
  cs_c2_t1: 'NGFW Firewall',
  cs_c2_t2: 'WAF',
  cs_c2_t3: 'Compliance Audit',
  cs_c3_industry: 'Healthcare',
  cs_c3_company: 'Private Clinic Chain',
  cs_c3_challenge: 'Patient records were scattered across clinics, the appointment system was outdated, doctors could not access cross-clinic medical histories, and data privacy compliance regulations were required.',
  cs_c3_solution: 'Developed a unified clinic management system integrating appointments, medical records, medication management and billing, with GDPR-compliant data encryption and access controls.',
  cs_c3_r1_metric: '70%',
  cs_c3_r1_label: 'Scheduling Efficiency',
  cs_c3_r2_metric: 'GDPR',
  cs_c3_r2_label: 'Compliance Passed',
  cs_c3_r3_metric: '8',
  cs_c3_r3_label: 'Clinics Unified',
  cs_c3_t1: 'Healthcare System',
  cs_c3_t2: 'Privacy Compliance',
  cs_c3_t3: 'Data Security',
  cs_cta_title: 'Your Business Could Be Our Next Success Story',
  cs_cta_desc: 'Whether it\'s system development, network infrastructure or cybersecurity — contact our technical consultants today for a free assessment',
  cs_cta_btn: 'Free Technical Assessment',

  // ── About Page ────────────────────────────────────
  about_badge: 'About Us',
  about_hero_title1: 'Global Enterprise IT Services',
  about_hero_title2: 'Your Trusted Technology Partner',
  about_hero_desc: 'A&B System has been serving enterprises worldwide for over 15 years. Our team of seasoned IT professionals is dedicated to delivering reliable system development, network infrastructure, and cybersecurity solutions across international markets.',
  about_stat1_num: '15+',
  about_stat1_label: 'Years of Experience',
  about_stat2_num: '200+',
  about_stat2_label: 'Projects Completed',
  about_stat3_num: '24/7',
  about_stat3_label: 'Round-the-Clock Support',
  about_mission_badge: 'Our Mission',
  about_mission_title1: 'Every Business Deserves',
  about_mission_title2: 'Enterprise-Grade IT Protection',
  about_mission_desc1: "A&B System believes that world-class IT infrastructure and cybersecurity should not be exclusive to large corporations. Our mission is to deliver enterprise-grade technology solutions to businesses of all sizes worldwide — at a cost that makes sense.",
  about_mission_desc2: 'We are more than just a technology service provider — we are your long-term strategic IT partner. From the initial consultation to ongoing post-deployment support, we are with you every step of the way.',
  about_mission_i1_title: 'Business-First Approach',
  about_mission_i1_desc: 'We deeply understand your business needs before proposing tailored solutions — never one-size-fits-all',
  about_mission_i2_title: 'Full Transparency',
  about_mission_i2_desc: 'Clear project timelines, cost breakdowns and technical explanations — no hidden fees, ever',
  about_mission_i3_title: 'Long-Term Partnership',
  about_mission_i3_desc: 'Ongoing support after project completion — we grow alongside your business',
  about_mission_uptime_label: 'Average System Uptime',
  about_team_badge: 'Technical Team',
  about_team_title: 'Meet Our Expert Team',
  about_team_desc: 'Every member holds multiple international certifications, bringing extensive hands-on experience to enterprises globally',
  about_tm1_role: 'Founder & Technical Director',
  about_tm1_bio: 'Former Cisco-certified engineer with 20 years of enterprise network architecture experience',
  about_tm2_role: 'Head of Information Security',
  about_tm2_bio: 'CISSP-certified professional with extensive experience in financial sector security projects',
  about_tm3_role: 'Director of System Development',
  about_tm3_bio: 'Cloud architecture specialist who has led over 50 enterprise system development projects',
  about_tm4_role: 'Project Management Officer',
  about_tm4_bio: 'PMP-certified manager ensuring every project is delivered on time and exceeds client expectations',
  about_values_badge: 'Core Values',
  about_values_title: 'Principles We Stand By',
  about_values_desc: 'These values guide every decision we make and shape the way we work with our clients',
  about_v1_title: 'Security First',
  about_v1_desc: "Information security is a non-negotiable core principle in every project. We protect our clients' digital assets to the highest standards.",
  about_v2_title: 'Technical Excellence',
  about_v2_desc: 'We continuously sharpen our technical capabilities and hold multiple international certifications to ensure our services meet the highest industry benchmarks.',
  about_v3_title: 'Transparency & Integrity',
  about_v3_desc: 'Clear project progress, cost explanations, and regular reports build long-lasting trust with every client.',
  about_v4_title: 'Client-Centric',
  about_v4_desc: "We take time to deeply understand each client's business needs, delivering targeted solutions rather than generic packages.",
  about_v5_title: 'Rapid Response',
  about_v5_desc: 'We commit to a 30-minute emergency response time, ensuring your business is never disrupted by IT issues.',
  about_v6_title: 'Ongoing Support',
  about_v6_desc: 'Technical support and system optimization continue long after project delivery — we are your long-term IT partner.',
  about_why_badge: 'Why Choose Us',
  about_why_title: 'Six Key Advantages of A&B System',
  about_why_desc: 'More than just an IT service provider — your most reliable long-term technology partner',
  about_r1_num: '01',
  about_r1_title: 'Deep Technical Certification',
  about_r1_desc: 'Our core technical team holds internationally recognized certifications, including Cisco CCNP, Fortinet NSE, and Palo Alto PCNSE.',
  about_r2_num: '02',
  about_r2_title: 'Tailored Solutions',
  about_r2_desc: 'No cookie-cutter approaches. We analyse your business processes in depth and design the most suitable IT solution to maximise your return on investment.',
  about_r3_num: '03',
  about_r3_title: 'Fully Transparent Project Management',
  about_r3_desc: 'Regular progress reports clearly outline deliverables and outcomes. Clients stay informed at every stage — no hidden fees, no surprises.',
  about_r4_num: '04',
  about_r4_title: '24/7 Emergency Response',
  about_r4_desc: 'Year-round emergency technical support with an average response time under 30 minutes, ensuring your business operates without interruption.',
  about_r5_num: '05',
  about_r5_title: 'Multi-Industry Expertise',
  about_r5_desc: "We serve retail, finance, manufacturing, healthcare and more — with deep knowledge of each industry's compliance requirements and IT pain points.",
  about_r6_num: '06',
  about_r6_title: 'Long-Term Partnerships',
  about_r6_desc: 'Many of our clients have partnered with us for years. Their continued trust reflects the quality, reliability, and consistency of our services.',
  about_why_cta: 'Free Consultation',

  // ── Contact Page ──────────────────────────────────
  contact_badge: 'Contact Us',
  contact_hero_title1: 'Start Your',
  contact_hero_title2: 'IT Transformation Journey',
  contact_hero_desc: 'Reach us via the form below, WhatsApp, or phone. Our technical consultants will respond to your enquiry within 24 hours.',
  contact_badge1_label: 'Reply within 24 hours',
  contact_badge1_sub: 'Mon–Fri  9:00–18:00',
  contact_badge2_label: 'Free Consultation',
  contact_badge2_sub: 'No hidden fees whatsoever',
  contact_badge3_label: 'NDA Protected',
  contact_badge3_sub: 'Your information is fully confidential',
  contact_form_title: 'Send an Enquiry',
  contact_form_desc: 'Fill in the form below and our technical consultant will get back to you as soon as possible',
  contact_field_name: 'Contact Name',
  contact_field_company: 'Company Name',
  contact_field_email: 'Email Address',
  contact_field_message: 'Describe Your Requirements',
  contact_placeholder_name: 'John Smith',
  contact_placeholder_company: 'ABC Company Ltd.',
  contact_placeholder_email: 'info@company.com',
  contact_placeholder_message: 'Briefly describe your business needs or IT challenges. Max 500 characters.',
  contact_submit: 'Submit Enquiry',
  contact_submitting: 'Submitting...',
  contact_success_title: 'Enquiry submitted successfully!',
  contact_success_desc: 'We will get back to you within 24 hours. Thank you for reaching out.',
  contact_error_title: 'Submission failed, please try again',
  contact_error_desc: 'Or contact us directly via WhatsApp: +852 2000 0000',
  contact_info_title: 'Contact Information',
  contact_info_desc: 'Our technical consultants are always ready to answer your IT questions. Choose the most convenient way to reach us.',
  contact_email_label: 'Email',
  contact_email_sub: 'Reply within 24 hours on business days',
  contact_emergency_title: '24/7 Emergency Support',
  contact_emergency_desc: 'For critical IT incidents — server downtime, network outage, or security breach — call our emergency hotline. We guarantee a response within 30 minutes.',
  contact_partners_label: 'Authorised Partners',
};

export default en;
